import { useMemo } from 'react'
import type { BoxDto } from '../types/generated'

export const useBoxChoices = (params: { box: BoxDto }) => {
  // BoxChoiceDto already includes user_vote_summary field populated by API
  // for authenticated users, so no additional fetch needed
  const boxChoices = useMemo(() => {
    return [...params.box.boxChoices].sort(
      (a, b) => a.choiceIndex - b.choiceIndex,
    )
  }, [params.box.boxChoices])

  // Find the winning choice
  const winningChoice = useMemo(() => {
    if (params.box.winner === null) {
      return null
    }

    return boxChoices
      .filter(c => Boolean(c.user_vote_summary))
      .find(choice => choice.choiceIndex === params.box.winner)
  }, [params.box.winner, boxChoices])

  return {
    winningChoice,
    boxChoices,
  }
}
